export type NestingStringKeyObject = {
  [key: string]: string | NestingStringKeyObject;
};

type FlatStringKeyObject = {
  [key: string]: string;
};

const flattenObj = (obj: NestingStringKeyObject, join: string = '.') => {
  const toReturn: FlatStringKeyObject = {};

  for (const i in obj) {
    if (!obj.hasOwnProperty(i)) {
      continue;
    }

    const objectValue = obj[i];

    if (typeof objectValue === 'object') {
      const flatObject = flattenObj(objectValue);

      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) {
          continue;
        }

        toReturn[`${i}${join}${x}`] = flatObject[x];
      }
    } else {
      toReturn[i] = objectValue;
    }
  }

  return toReturn;
};

export default flattenObj;
